<template>
  <div style="margin: 0 16px">
    <div class="content-input" style="margin: -16px 0 24px">
      <div class="content-input-item">
        <label>记录类型：</label>
        <el-select v-model="state" placeholder="Select" style="width: 7em">
          <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="content-input-item" v-if="pageType > 2">
        <DatePickerRange title="更新时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
      </div>
      <div class="content-input-item">
        <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
      </div>
      <div class="content-input-item">
        <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%"
        border
        @cell-click="toggleSelection"
        v-loading="listLoading"
    >
      <el-table-column label="头像" width="140">
        <template #default="scope">
          <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
        </template>
      </el-table-column>
      <el-table-column property="" label="基本信息" width="300">
        <template #default="scope">
          <UserInfoList :row="scope.row" showList="name,phone,uid,city,birth" :isDialog="true"/>
          <p>学历：<span v-if="scope.row.authEdu">{{scope.row.authEdu.education==1?'初中':scope.row.authEdu.education==2?'中专/职高/技校':scope.row.authEdu.education==3?'高中':scope.row.authEdu.education==4?'大专':scope.row.authEdu.education==5?'本科':scope.row.authEdu.education==6?'硕士':scope.row.authEdu.education==7?'博士':scope.row.authEdu.education==8?'博士后':''}}</span></p>
          <p>学校：<span v-if="scope.row.authEdu">{{scope.row.authEdu.schoolName}}</span></p>
          <p>学历认证：<span v-if="scope.row.authEdu">{{scope.row.authEdu.eduState == 2?'已认证':'未认证'}}</span></p>
          <p>身份认证：<span v-if="scope.row.identityAuth">{{scope.row.identityAuth.overallAuthState == 2?'已认证':'未认证'}}</span></p>
        </template>
      </el-table-column>
      <el-table-column property="statDate" :label="pageType == 2 || pageType == 4?'被推荐时间':'推荐时间'" />
      <el-table-column property="" :label="pageType == 2 || pageType == 4?'被操作结果':'操作结果'">
        <template #default="scope">
          <p>{{scope.row.state == 1?'无感':scope.row.state == 2?'心动':''}}</p>
        </template>
      </el-table-column>
      <el-table-column property="updateTime" :label="pageType == 2 || pageType == 4?'被操作时间':'操作时间'" />
    </el-table>
    <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api'
import { getRecommendUserList } from '@/api/url'
import UserInfoList from "@/components/resume/UserInfoList";
import SearchComponents from "@/components/SearchComponents";
import ImgViewer from "@/assets/js/imageViewer";
import DatePickerRange from '../../../components/DatePickerRange_1'
export default {
  name: "GreetingDateNum",
  components: { UserInfoList, SearchComponents, DatePickerRange },
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.userId,
      pageType: this.value.pageType,
      statDate: this.value.statDate,

      stateArray: [
        {label: '不限', value: -1},
        {label: '无感', value: 1},
        {label: '心动', value: 2},
      ],
      state: -1,


      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '用户日志', value : 4},
        {label : '身份证号', value : 5},
        {label : '实名', value : 6},
        {label : '自我介绍', value : 7},
      ],
      searchType: 1,
      searchValue: '',

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      //注册/进入时间
      startTime: '',
      endTime: '',
      isChecked: true,

    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.userId;
      param['state'] = this.state;
      param['pageType'] = this.pageType;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['startTime'] = this.pageType > 2?this.startTime:this.statDate;
      param['endTime'] = this.pageType > 2?this.endTime:this.statDate;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getRecommendUserList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {

    },

  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
